import { Link } from 'react-router-dom';
import { Paintbrush } from 'lucide-react';

function InteriorFinishes() {
  return (
    <div className="pt-28">
      {/* Hero Section with Background Image */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1482731215275-a1f151646268?fm=webp&q=70&auto=format&fit=max&w=1920)' }}
        ></div>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Interior Finishes & <span className="text-gold">Custom Detailing</span>
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Meticulous interior finishing and custom detailing for exceptional spaces
          </p>
        </div>
      </section>

      <section className="bg-black py-32 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-gray-300 space-y-6 text-lg leading-relaxed">
            <p>
              The quality of interior finishes defines the look, feel, and functionality of any space. Williams Diversified specializes in premium interior finishing work that transforms buildings into beautiful, functional environments.
            </p>
            <p>
              Our skilled craftsmen pay meticulous attention to every detail, from perfectly smooth drywall installations to precision millwork and custom features. We work with premium materials and the latest techniques to deliver flawless results.
            </p>
            <h3 className="text-3xl font-bold text-white mt-12 mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Our Services</h3>
            <ul className="space-y-4">
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Drywall installation and finishing</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Commercial painting and coating</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Flooring installation (all types)</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Ceiling systems</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Custom millwork and cabinetry</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Trim and finish carpentry</span></li>
            </ul>
          </div>
        </div>
      </section>

      <section className="bg-black py-24 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Transform Your <span className="text-gold">Interiors</span></h3>
          <Link to="/contact" className="inline-block bg-gold hover:bg-gold-dark text-black font-bold py-5 px-12 rounded text-lg transition-all transform hover:scale-105 uppercase tracking-wider">Contact Us</Link>
        </div>
      </section>
    </div>
  );
}

export default InteriorFinishes;